// AddStreamGraphicsMedia.tsx
import React from "react";
import { Box, Grid } from "@mui/material";
import FileUploadSection from "../../../components/FileUploadSection";

interface AddStreamGraphicsMediaProps {
  handleThumbnailChange: (files: File[]) => void;
  handleSlideshowChange: (files: File[]) => void;
  handleProgramChange: (files: File[]) => void;
}

const AddStreamGraphicsMedia: React.FC<AddStreamGraphicsMediaProps> = ({
  handleThumbnailChange,
  handleSlideshowChange,
  handleProgramChange,
}) => {
  return (
    <Box>
      <Grid container spacing={4}>
        <Grid size={{ xs: 12, md: 6 }}>
          <FileUploadSection
            title="Upload Thumbnail"
            maxFiles={2}
            onFilesChange={handleThumbnailChange}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <FileUploadSection
            title="Upload Slideshow"
            maxFiles={2}
            acceptedFileTypes="video/mp4"
            onFilesChange={handleSlideshowChange}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <FileUploadSection
            title="Upload Program"
            maxFiles={2}
            acceptedFileTypes="application/pdf"
            onFilesChange={handleProgramChange}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default AddStreamGraphicsMedia;
